export const SubscriptionStatusTerms = {
  active: "active",
  terminated: "label_terminated",
  stopped: "stopped_label",
  registered: "title_registered",
  cancelled: "cancelled",
};
